import { useCallback } from "react";
import * as XLSX from "xlsx";

const useExporter = () => {
  // Function to export JSON data to Excel and trigger download
  const exportToExcel = useCallback((data, filename) => {
    // Omvandla JSON till ett kalkylblad
    const worksheet = XLSX.utils.json_to_sheet(data);
    // Skapa en arbetsbok och lägg till kalkylbladet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Data");
    // Skriv filen och trigga nedladdning
    XLSX.writeFile(workbook, `${filename}.xlsx`); //REMOVED: _${format(new Date(), 'yyyy-MM-dd_HH-mm')}
  }, []);

  // Funktion för att exportera flera datauppsättningar som separata Excel-filer
  const handleExport = useCallback((jsonData, filename) => {
    Object.keys(jsonData).forEach((key) => {
      exportToExcel(jsonData[key], filename); //REMOVED: `${filename}_${key}`
    });
  }, [exportToExcel]);

    // Function to export an array of dictionaries as multiple worksheets in a single Excel file
    const exportMultipleSheets = useCallback((dataArray, filename) => {
      const workbook = XLSX.utils.book_new();
      
      dataArray.forEach((dataDict) => {
        Object.keys(dataDict).forEach((key) => {
          const worksheet = XLSX.utils.json_to_sheet(dataDict[key]);
          XLSX.utils.book_append_sheet(workbook, worksheet, key);
        });
      });
  
      XLSX.writeFile(workbook, `${filename}.xlsx`);
    }, []);

  return { handleExport, exportMultipleSheets };
};

export default useExporter; 


/* import Papa from "papaparse";
import { format } from 'date-fns';

const useExporter = () => {
  // Function to convert JSON data to CSV and trigger download
  const exportToCSV = useCallback((data, filename) => {
    const csv = Papa.unparse(data);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", filename);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }, []);

  // Function to handle exporting multiple pages (keys in the dictionary)
  const handleExport = useCallback((jsonData, filename) => {
    Object.keys(jsonData).forEach((key) => {
      exportToCSV(jsonData[key], `${filename}_${key}_${format(new Date(), 'yyyy-MM-dd hh:mm')}.csv`);
    });
  }, [exportToCSV]);

  return { handleExport };
};

export default useExporter; */
